module.exports = __webpack_public_path__ + "icon-location-green.png?3b715424fd8695c7ad468a9ca8708022";